import { selectContentMarkNodes } from '@newStore/documentUI/documentUISelectors';
import { useCallback } from 'react';
import { Overlay, Popover } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import useEditorPopOver from './useEditorPopOver';

const MarkPopover = ({ editor }) => {
  const marks = useSelector(selectContentMarkNodes);
  const findItem = useCallback(
    (target: HTMLElement) => marks.find((term) => term.href === target.getAttribute('data-href')),
    [marks],
  );
  const popOverData = useEditorPopOver(findItem, 'span[data-rel="mark-explanation"]', editor);

  return (
    popOverData.target && (
      <Overlay show={true} target={popOverData.target} placement="top" containerPadding={20}>
        <Popover id={editor?.id} title="Markeerverklaring">
          <div dangerouslySetInnerHTML={{ __html: popOverData.content }} />
        </Popover>
      </Overlay>
    )
  );
};

export default MarkPopover;
